import PageLayout from '@/components/feature/PageLayout';
import { interiorProjects } from '@/mocks/projects';

export default function Interiors() {
  const secondProject = interiorProjects[1];
  const thirdProject = interiorProjects[2];
  const fourthProject = interiorProjects[3];

  return (
    <PageLayout>
      <div className="bg-black pt-4 md:pt-8 pb-16 md:pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10">

          {/* Titre principal */}
          <div className="text-center mb-[4.55rem] md:mb-[6.5rem] pt-0">
            <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mx-auto px-4 max-w-full md:max-w-3xl">
              Quel que soit votre budget,<br className="hidden md:block" /> chaque projet mérite la même exigence
            </h1>
          </div>

          {/* Section 1 — Texte */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Chaque centimètre devient une opportunité de création. Confort et fluidité trouvent naturellement leur place
              </p>
            </div>

            {fourthProject && (
              <div className="flex flex-col md:flex-row gap-4 md:gap-6">
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src={fourthProject.afterSrc}
                      alt={`${fourthProject.title} — après`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/89e172cc-f033-42d0-ac6d-a818072e0006_compressed_Espaces-interieurs-Final-Salou-SDB-Apres.webp"
                      alt={`${fourthProject.title} — après 2`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Section 2 — Texte */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Tout commence par une simple ossature.<br />Une création minérale sur mesure prend naturellement sa place
              </p>
            </div>

            {secondProject && (
              <div className="flex flex-col md:flex-row gap-4 md:gap-6">
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src={secondProject.beforeSrc}
                      alt={`${secondProject.title} — avant`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-4 left-4 px-3 py-1 bg-black/70 text-white/80 text-xs tracking-[0.2em] uppercase rounded-full backdrop-blur-sm">
                    Avant
                  </div>
                </div>
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src={secondProject.afterSrc}
                      alt={`${secondProject.title} — après`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 text-black text-xs tracking-[0.2em] uppercase rounded-full backdrop-blur-sm">
                    Après
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Section 3 — Texte */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Il suffit parfois d'un sol pour changer l'harmonie d'une cuisine. Le choix du carrelage et la précision de sa pose en révèlent toute la personnalité 
              </p>
            </div>

            {thirdProject && (
              <div className="flex flex-col md:flex-row gap-4 md:gap-6">
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src={thirdProject.beforeSrc}
                      alt={`${thirdProject.title} — avant`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-4 left-4 px-3 py-1 bg-black/70 text-white/80 text-xs tracking-[0.2em] uppercase rounded-full backdrop-blur-sm">
                    Avant
                  </div>
                </div>
                <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                  <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                    <img
                      src={thirdProject.afterSrc}
                      alt={`${thirdProject.title} — après`}
                      className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute top-4 right-4 px-3 py-1 bg-white/90 text-black text-xs tracking-[0.2em] uppercase rounded-full backdrop-blur-sm">
                    Après
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Section 5a — Mur SDB locaux Pyves */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Le caractère d'une pièce naît parfois d'un seul mur. Le relief et la précision de sa pose en font l'élément central de la réalisation
              </p>
            </div>

            <div className="relative overflow-hidden rounded-md bg-background-900 max-w-3xl mx-auto">
              <div className="relative w-full" style={{ aspectRatio: '3 / 4' }}>
                <img
                  src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/4d766d09-9da0-4afe-9510-69a9ce7cb0af_compressed_Espaces-interieurs-Final-Mur-sdb-locaux-Pyves.webp"
                  alt="Salle de bain locaux Pyves — vue d'ensemble"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </section>

          {/* Section 5b — WC cohérence sol et bâti-support */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Le véritable luxe réside dans les détails, où la précision des alignements et des découpes révèle toute la finesse de la réalisation
              </p>
            </div>

            <div className="relative overflow-hidden rounded-md bg-background-900 max-w-3xl mx-auto">
              <div className="relative w-full" style={{ aspectRatio: '3 / 4' }}>
                <img
                  src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/b60c328a-5665-40bd-8c25-9c20621260ba_compressed_Espaces-interieurs-Final-wc-Coherence-sol-et-bati-support.webp"
                  alt="WC — cohérence sol et bâti-support"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </section>

          {/* Section 5c — SDB principale Salou */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Comme les pièces d'un puzzle, chaque carreau trouve naturellement sa place. Le veinage est minutieusement composé pour assurer une parfaite continuité visuelle
              </p>
            </div>

            <div className="relative overflow-hidden rounded-md bg-background-900 max-w-3xl mx-auto">
              <div className="relative w-full" style={{ aspectRatio: '3 / 4' }}>
                <img
                  src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/6aea55c2-63c5-486d-a6bc-c17eb9b4d368_compressed_Espaces-interieurs-Salou--SDB-Principale.webp"
                  alt="Salle de bain principale Salou"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </section>

          {/* Section 5d — Toilettes Salou */}
          <section className="mb-14 md:mb-28">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-8">
              <p className="text-center text-white text-base md:text-xl leading-snug md:leading-relaxed max-w-full md:max-w-3xl px-4 min-w-0 tracking-[0.15em] uppercase">
                Même les plus petits espaces méritent une attention particulière. Pour Romuald, aucune pièce n'est secondaire. Chaque détail compte
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-6">
              <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                  <img
                    src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/6dad85ff-3862-4665-8148-dffd573d254c_compressed_Espaces-interieurs-Salou-Toilettes-vue-du-couloir.webp"
                    alt="Toilettes Salou — vue du couloir"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="relative flex-1 overflow-hidden rounded-md bg-background-900">
                <div className="relative w-full" style={{ aspectRatio: '4 / 5' }}>
                  <img
                    src="https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/2b7440ce-1a1d-43d5-a187-a28e953cfe3e_compressed_Espaces-interieurs-Salou-Toilettes-de-linterieur.webp"
                    alt="Toilettes Salou — vue de l'intérieur"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </PageLayout>
  );
}